import React, { useState } from "react";

export const Navbar = ({ currentPage, setPage, isDark, toggleDark, c }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const navItems = ["Home", "Projects", "About", "Skills", "Contact"];

  const bg = isDark ? "rgba(12,19,36,0.8)" : "rgba(244,246,255,0.85)";

  return (
    <nav style={{
      position: "fixed", top: 0, width: "100%", zIndex: 50,
      background: bg,
      backdropFilter: "blur(20px)",
      borderBottom: `1px solid ${isDark ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.06)"}`,
      boxShadow: "0 4px 32px rgba(0,0,0,0.2)",
    }}>
      <div style={{
        display: "flex", justifyContent: "space-between", alignItems: "center",
        maxWidth: 1280, margin: "0 auto", padding: "0 64px", height: 80,
      }}>
        <div style={{
          fontFamily: "'JetBrains Mono', monospace",
          fontSize: 22, fontWeight: 700, color: c.primary,
          letterSpacing: "-0.02em", cursor: "pointer"
        }} onClick={() => setPage("Home")}>
          SYNTAX_ERR
        </div>

        <div style={{ display: "flex", gap: 32, alignItems: "center" }}>
          {navItems.map((item) => (
            <button key={item}
              className={`nav-link${currentPage === item ? " active" : ""}`}
              style={{
                color: currentPage === item ? c.primary : c.onSurfaceVariant,
                borderBottomColor: c.primary,
              }}
              onClick={() => setPage(item)}
            >
              {item}
            </button>
          ))}

          <button onClick={toggleDark} style={{
            background: "transparent", border: "none", cursor: "pointer",
            color: c.primary, padding: "6px 8px", borderRadius: 8,
            display: "flex", alignItems: "center",
            transition: "background 0.2s",
          }}
            title={isDark ? "Light mode" : "Dark mode"}
          >
            <span className="material-symbols-outlined" style={{ fontSize: 22 }}>
              {isDark ? "light_mode" : "dark_mode"}
            </span>
          </button>
        </div>
      </div>
    </nav>
  );
};